import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

var getSize = function getSize(props) {
  switch (props.size) {
    case "small":
      return "80px";

    case "medium":
      return "120px";

    case "large":
      return "160px";

    case "xlarge":
      return "200px";

    case "xxlarge":
      return "240px";

    default:
      return "100%";
  }
};

var size = css(["max-width:", ";"], getSize);
var VisualStyle = styled.div.withConfig({
  displayName: "Visual__VisualStyle",
  componentId: "sc-7w080k-0"
})(["", ";display:block;flex:0 0 auto;height:100%;margin-left:auto;margin-right:auto;pointer-events:none;user-select:none;"], size);
VisualStyle.propTypes = {
  size: PropTypes.string
};

var Visual = function Visual(_ref) {
  var component = _ref.component,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(VisualStyle, {
    size: size
  }, component);
};

export default Visual;